import {registerFCM, notificationManager} from './notificationManager';
import { handleFacebookLogin,handleFacebookLogout } from './facebookManager';
import { handleAppleLogin } from './appleManager';
import { store } from "../stores/mainStore";
import { comm } from '../comm';

export class CommandQueue {
	commands = [];
	processing = false;
	constructor(commands){
		this.commands = commands || [];
		this.process();
	}
	push(){
		this.commands.push(...arguments);
		this.process();
	}
	process(){
		if(this.commands.length){
			this.processing = true;
			var c = this.commands.shift();
			let m = window.manager;
			// window.WrapperApp.postMessage(JSON.stringify(c));
			switch (c[0]) {
				case 'register':
					console.log('register for push', c);
					registerFCM(c[1]);
					break;
				case 'notify':
					notificationManager(JSON.parse(c[1]), c[2])
					break;
				case 'facebook-success':
					var fbData = JSON.parse(c[1]);
					handleFacebookLogin(fbData);
					// window.WrapperApp.postMessage('calling handleFacebookLogin'+JSON.stringify(c[1]));
					break;
				case 'facebook-logout':
					handleFacebookLogout();
					// window.WrapperApp.postMessage('calling handleFacebookLogout'+JSON.stringify(c[1]));
					break;
				case 'apple-success':
					//process successful apple signin
					var appleIdCredentialUser = c[1];
					handleAppleLogin(appleIdCredentialUser);
					break;
				case 'videoad-loaded':
					console.log("********* RECEIEVED videoad-loaded from native")
					store.videoAdIsLoaded = true;
					break;
				case 'videoad-played':
					console.log("********* RECEIEVED videoad-played from native")
					store.videoAdIsLoaded = false;
					break;
				case 'videoad-closed':
					console.log("********* RECEIEVED videoad-closed from native")
					if(m.ui.inGameAfterInterstitial === false)
						m.ui.continueShowRoundBanner();
					break;
				case 'rewardad-closed':
					console.log("********* RECEIEVED REWARDAD-CLOSED from native")
					let rewardValid = c[1] === 'true' ? true : false;
					if(rewardValid)
						m.processRewardAdClosed();
					else 
						store.modal = ''; //undim screen
					break;
				case 'rewardad-loaded':
					console.log("********* RECEIEVED rewardad-loaded from native")
					store.rewardAdIsLoaded = true;
					break;
				case 'rewardad-played':
					console.log("********* RECEIEVED rewardad-played from native")
					store.rewardAdIsLoaded = false;
					store.videoCloseButtonVisible = false;
					store.modal = "";
					break;
				case 'closeButton-pressed':
					console.log("********* RECEIEVED closeButton-pressed from native")
					if(store.windowToClose)
						store.windowToClose.close();
					break;
				case 'device-platform':
					console.log('platform:', c);
					setPersistentStorage('platform',c[1]);
					store.devicePlatform = c[1];
					break;
				case 'app-version':
					console.log('app version:', c[1]);
					store.wrapperVersion = c[1];
					break;
				case 'local-path':
					console.log('local path:', c[1]);
					store.wrapperLocalPath = c[1];
					break;
				case 'purchase-complete':
					console.log('purchase complete:', c);
					var receiptObj = {};
					let isAndroid = store.devicePlatform === 'android';
					var receipt = c[1];
					if(isAndroid === true) {
						var payload = JSON.parse(receipt.Payload);
						receiptObj.json = payload.json;
						receiptObj.signature = payload.signature;
					} else {
						receiptObj = JSON.parse(receipt);
					}
					comm.PurchaseProduct(receiptObj)
					.then((response) => {
						if(response.ErrorCode === 0) {
							store.purchaseComplete = true;
							// store.modal = "purchaseComplete";
							store.hasPurchasedIAP = "true";
						} else {
							store.modal = "";
						}
					});
					break;
				case 'purchase-failed':
					console.log('purchase failed:', c);
					store.modal = "purchaseCancelled";
					break;
				case 'product-item':
					var data = JSON.parse(c[1]);
					store.products.push(data);
					break;
				case 'store-complete':
					store.productStoreReady = true;
					break;
				case 'focus-true':		//resuming
					store.focus = true;
					store.turnsThisSession = 0;
					break;
				case 'focus-false':		//about to pause
					store.focus = false;
					if(store.activeMatch){
						// store.modal = 'resume';
					}
					break;
				case 'first-launchtime':		//resuming
					store.firstLaunchUtcSecs = c[1];
					store.hasPurchasedIAP = c[2];
					break;
				case 'back-button':
					if(store.topBar.hide === true && store.activeMatch && store.activeMatch.matchId) // are we in-game
						m.ui.processAndroidBackButton();
					else {
						//process back button for lobby screens.
						var el = document.getElementById('topbar-nav-button');
						if(el){
							el.click();
						}
					}
					break;
				case 'send-react-image':
					let name = c[1];
					let textImageData = c[2];	// empty string ('') if request failed/file not found
					if(window.b64Images[name]){
						if(textImageData){
							window.b64Images[name].resolve(textImageData);
						} else {
							//this is the 404 state
							window.b64Images[name].resolve('');
						}
					} else {
						console.error('b64 image sent, but no promise was listening: '+name);
					}
					// // console.log("******TEXTIMAGEDATA name "+name+": "+textImageData);
					break;
				case 'send-localstorage':
					let wrapperData = c[1];
					// console.log("received from wrapperstorage:"+JSON.stringify(wrapperData));
					// // document.getElementById('loadLog').innerHTML += JSON.stringify(wrapperData);
					try {
						// wrapperData = JSON.parse(wrapperData);
						Object.keys(wrapperData).forEach((k) => {
							// console.log('wrapperstorage item : '+ k + ' : ' + wrapperData[k]);
							localStorage.setItem(k, wrapperData[k]);
						});
						// document.getElementById('loadLog').innerHTML += " * storage * "
					} catch (error) {
						// document.getElementById('loadLog').innerHTML += " * storage-error * "
						// // document.getElementById('loadLog').innerHTML += '::' + error;
						console.warn(error);
					}
					store.localStorageSynced = true;
					// store.localStorageSynced = true;
					break;
				case 'command-processed':
					console.log("********* RECEIEVED command-processed from native")
					store.wrapperCommandProcessing = false;
					if(window.commands.length){
						var message = window.commands.shift();
						store.wrapperCommandProcessing = true;
						window.location.href = "uniwebview://"+message;
					}
					break;
				case 'test-command':
					console.log("********* RECEIEVED test-command from Unity")
					break;
				default:
				console.warn('command not found', c[0], c);
				break;
			}
		}
		if(this.commands.length){
			this.process();
		} else {
			this.processing = false;
		}
	}
}
